import React from "react"

import {
    Container,
    PageContent,
} from "client/components"

import CcApprovalLevel from "./approvalLevel"
import CcResponse from "./response"
import CcRequirementSettings from "./requirementSettings"
import CcReviewSettings from "./reviewSettings"

const Cc = () => (
    <Container>
        <PageContent>
            <CcApprovalLevel />
            <CcResponse />
            <CcRequirementSettings />
            <CcReviewSettings />
        </PageContent>
    </Container>
)
export default Cc
